import React, {useContext, useState, useEffect} from "react";
import omniscanLogo from "../images/omniscanlogo.png";
import PageHeader from "./components/PageHeader";
import LeftMenu from "./components/LeftMenu";
import NavigationCardFloor from "./components/NavigationCardFloor";
import HeadlineCard from "./components/HeadlineCard";
import {useHistory} from 'react-router-dom';
import db from '../constants/db';
import { store } from "../context/store.js";
import { CHANGE_SELECTED_FLOOR } from "../constants/action-types";

export default function Building(){
	
	const globalState = useContext(store);
  const { dispatch } = globalState;
	
	const history = useHistory();
	
	const[floors, setFloors] = useState([]);
	const [buildingId, setBuildingId] = useState("");
	const [buildingCode, setBuildingCode] = useState("");
	const [buildingName, setBuildingName] = useState("");
	const [buildingDescription, setBuildingDescription] = useState("");
	const [buildingPhoto, setBuildingPhoto] = useState("");
	
	useEffect(() => {
		const fetchFloors = async () => {
			
      const all = await db.floors
	    .where("buildingId") 
	    .equals(globalState.state.selectedBuilding.id)  
	    .toArray();
      setFloors(all);
    };
		try{
			let building = globalState.state.selectedBuilding;
			setBuildingId(building.id);
			setBuildingCode(building.code);
			setBuildingName(building.name);
			setBuildingDescription(building.description);
			setBuildingPhoto(building.photo);
		}
		catch(e){}
    fetchFloors();
	}, [globalState.state?.selectedBuilding]);
	
	const thisContainer = {
			display:'flex',
			flexDirection:"column",
			width:"100vw",
			height:'100vh'
	};
	
	const blankClick = () => {
		
	};

	
	const headlinePanelContainer = {
		display:"flex",
		width:"calc(100% - 80px)",
		marginLeft:"80px", 
		marginTop:"60px"
	};
	
	const floorContainer = {
		display:'flex',
		width:"calc(100% - 60px)",
		marginTop:"10px",
		marginLeft:"60px",
		overflow:"auto",
		alignSelf:"center",
		flexWrap:"wrap"
	};
	
	const getFloor = (id) => {
		return floors.find(floor => floor.id === id);
	};
	
	const selectFloor = (id) => {
	  const floor = getFloor(id);

	  dispatch({
	    type: CHANGE_SELECTED_FLOOR,
	    value: {
	      id: floor.id,
	      code: floor.code,
	      name: floor.name,
	      description: floor.description,
	      width: floor.width,
	      height: floor.height,
	      buildingId: floor.buildingId,
	      displayCode: floor.displayCode
	    }
	  });

	  history.push('/floor');
	};
	
	
	const floorDisplay = floors.map((item, index) => 
		<NavigationCardFloor
				id={item.id}
				title=""
				code={item.displayCode}
				clickFunction={selectFloor}
		/>
	);
	
	return (
		<div style={thisContainer}>
			<PageHeader
				title="Building/Facility"
			/>
			<LeftMenu/>
			<div style={headlinePanelContainer}>
					<HeadlineCard
						id={buildingId}
						title={buildingCode + ': ' + buildingName}
						description={buildingDescription}
						clickFunction={blankClick}
						photo={buildingPhoto}
				/>
			</div>
			<div style={floorContainer}>
				{floorDisplay}
			</div>
		</div>
	);
}